import { IsMobileDisplayActionTypes } from '../types';
import { IS_MOBILE_DISPLAY } from '../constants/actionTypes';

export const updateIsMobileDisplay = (isMobileDisplay: boolean): IsMobileDisplayActionTypes => ({
  type: IS_MOBILE_DISPLAY,
  payload: isMobileDisplay,
});
